import { Dialog, DialogProps } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { ReactNode } from "react";

/**
 * TODO - turn this into a styled component and find uses of action dialogs across codebase and replace with this component
 */

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      height: `calc(100% - 64px)`,
    },
  })
);

interface ActionDialogProps {
  children: ReactNode;
  onClose?: DialogProps["onClose"];
  open: boolean;
  maxWidth?: DialogProps["maxWidth"];
}

const ActionDialog = ({ children, onClose, open, maxWidth = "xl" }: ActionDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      classes={{
        paper: classes.paper,
      }}
    >
      {children}
    </Dialog>
  );
};

export default ActionDialog;
